export enum ApplicationType {
  NewRecruit = "NewRecruit",
  ForReinstatement = "ForReinstatement",
}
export const ApplicationDetailTemplate = {
  pages: [
    {
      name: "page1",
      elements: [
        {
          type: "radiogroup",
          name: "applicationType",
          isRequired: true,
          title: "Recruitment.application_type",
          preset: "radio",
          choices: [
            { text: "Recruitment.new_recruit", value: ApplicationType.NewRecruit },
            { text: "Recruitment.reinstatement", value: ApplicationType.ForReinstatement },
          ],
          requiredErrorText: "Recruitment.application_type_required_error",
        },
        {
          type: "text",
          tooltips: "Recruitment.collect_info_before_application",
          visibleIf: "{applicationType} = 'ForReinstatement'",
          name: "formerAgentCode",
          isRequired: true,
          title: "Recruitment.former_agent_code",
          placeholder: "Recruitment.input_your_agent_code",
          validators: [
            {
              type: "regex",
              text: "Recruitment.format_error",
              regex: /^[0-9]+$/,
            },
            {
              type: "regex",
              text: "Masukkan kode agen yang terdiri dari 8 digit.",
              regex: /^[0-9]{8}$/,
            },
          ],

          requiredErrorText: "Recruitment.former_agent_code_required_error",
        },
        {
          type: "text",
          visibleIf: "{applicationType} = 'ForReinstatement'",
          name: "recruiterName",
          isRequired: false,
          readOnly: true,
          title: "Recruitment.early_recruiter_name",
          placeholder: "",
          requiredErrorText: "",
        },
        {
          type: "text",
          visibleIf: "{applicationType} = 'ForReinstatement'",
          name: "leaderName",
          isRequired: false,
          readOnly: true,
          title: "Recruitment.early_leader_name",
          placeholder: "",
          requiredErrorText: "",
        },
        {
          type: "text",
          visibleIf: "{applicationType} = 'ForReinstatement'",
          name: "agentOffice",
          isRequired: false,
          readOnly: true,
          title: "Recruitment.early_agent_office",
          placeholder: "",
          requiredErrorText: "",
        },
        {
          type: "text",
          visibleIf: "{applicationType} = 'ForReinstatement'",
          name: "terminationDate",
          readOnly: true,
          isRequired: false,
          title: "Recruitment.termination_date",
          placeholder: "",
          requiredErrorText: "",
        },
        {
          type: "text",
          visibleIf: "{applicationType} = 'ForReinstatement'",
          name: "terminationCode",
          isRequired: false,
          readOnly: true,
          title: "Recruitment.early_reason_termination",
          placeholder: "",
          requiredErrorText: "",
        },
        // {
        //   type: "text",
        //   visibleIf: "{applicationType} = 'ForReinstatement'",
        //   inputType: "date",
        //   name: "licenseExpirationDate",
        //   readOnly: true,
        //   isRequired: false,
        //   title: "Recruitment.license_expiration_date",
        //   placeholder: "Recruitment.placeholder_select_license_expiration_date",
        //   requiredErrorText: "Recruitment.license_expiration_date_required_error",
        // },
        // {
        //   type: "text",
        //   visibleIf: "{applicationType} = 'ForReinstatement'",
        //   inputType: "date",
        //   name: "appointmentDate",
        //   readOnly: true,
        //   isRequired: false,
        //   title: "Recruitment.appointment_date",
        //   placeholder: "Recruitment.placeholder_select_appointment_date",
        //   requiredErrorText: "Recruitment.appointment_date_required_error",
        // },
        // {
        //   type: "text",
        //   visibleIf: "{applicationType} = 'ForReinstatement'",
        //   inputType: "date",
        //   name: "terminationDate",
        //   readOnly: true,
        //   isRequired: false,
        //   title: "Recruitment.termination_date",
        //   placeholder: "Recruitment.placeholder_select_termination_date",
        //   requiredErrorText: "Recruitment.termination_date_required_error",
        // },
      ],
    },
  ],
  showQuestionNumbers: "off",
};
